export default "__VITE_ASSET__B5UjpX$R__"